import { component } from 'picoapp'
import app from '../lib/app-instance'
import $ from '../lib/quantdom'
import { get } from '../lib/ajax'
import { sessionStorageSetItem } from '../lib/utils'

export default component((node) => {
  $(node).on('change', (e) => {
    e.preventDefault()
    const url = new URL(window.location)
    const collectionUrl = e.target.value
    // pull from updated product cards unless on a collection page
    if (url.pathname.includes('collection')) {
      url.searchParams.set('view', 'product-cards')
    } else {
      url.searchParams.set('view', 'new-product-cards')
    }

    $('.js-collection-link').attr('aria-selected', 'false')
    $(`.js-collection-link[href="${collectionUrl}"]`).attr('aria-selected', 'true')

    if (sessionStorage.getItem(collectionUrl + url.search)) {
      replaceHTML(collectionUrl, sessionStorage.getItem(collectionUrl + url.search), false)
    }

    get(collectionUrl + url.search)
      .then((res) => {
        let currentActiveLink = e.target.value
        if (currentActiveLink === collectionUrl) {
          url.searchParams.delete('view')
          // prevent updating url unless on a collection page
          if (url.pathname.includes('collection')) {
            replaceHTML(collectionUrl, res)
          } else {
            replaceHTML(collectionUrl, res, false)
          }
        }
      })
      .catch((err) => {
        console.log('Could not get collection', err)
      })
  })

  function replaceHTML(collectionUrl, res, pushState = true) {
    const url = new URL(window.location)
    const parser = new DOMParser()
    const doc = parser.parseFromString(res, 'text/html')
    const el = doc.querySelector('.js-product-grid')
    const html = el.innerHTML
    const title = el.getAttribute('data-collection-title')
    const loadMoreState = el.getAttribute('data-load-more-hidden')
    const totalProducts = el.getAttribute('data-product-count')
    const productsPerPage = el.getAttribute('data-products-per-page')

    $('.js-load-more-wrapper').attr('aria-hidden', loadMoreState)
    $('.js-product-grid').html(html)
    $('.js-collection-title').text(title)
    // $('.js-collection-select').el().value = collectionUrl
    $('.js-product-grid').attr('data-products-per-page', productsPerPage)
    $('.js-product-grid').attr('data-product-count', totalProducts)

    if (window?.productScroll && window?.productScroll?.active) {
      window.productScroll.stop()
    }

    sessionStorageSetItem(collectionUrl + url.search, res)
    if (pushState) {
      history.pushState({}, '', collectionUrl + url.search)
    }

    app.mount()
  }
})
